import { searchParamKeys } from '../../shared/configs/searchParams';
import { useSearchParamsSelector } from '../../shared/packages/searchParamsManager';
import {
  parsedAcceptanceSlugsIsEqual,
  parseAcceptanceSlug,
} from '../../shared/packages/acceptance';
import { useRoomsForIndividualDates } from '../../api/roomsForIndividualDates';

const { acceptance: acceptanceKey } = searchParamKeys;

export const useRoomListForIndividualDates = ({ options } = {}) => {
  const params = useSearchParamsSelector((state) => {
    return parseAcceptanceSlug(state[acceptanceKey]);
  }, parsedAcceptanceSlugsIsEqual);

  return useRoomsForIndividualDates({
    params,
    options,
  });
};
